export default __webpack_public_path__ + "static/Entenda0002-108bd8d0f249903accf3a87e807ae86f.jpg";